import  { useEffect, useState } from "react";
import SingleAssetDetail from "./SingleAssetDetail";
import VerificationSuccess from "./VerificationSuccess";

type AppProps = {
  handleReset: () => void;
  singleFixedAsset: any;
  history: any;
  message: string | null;
  clientCode: string | null;
  onClose?: () => void;
  handleSubmit: (condition: string, id: string) => void;
};

const AssetDetails = ({
  handleReset,
  singleFixedAsset,
  handleSubmit,
  message,
  onClose,
  history,
  clientCode,
}: AppProps) => {
  const [condition, setCondition] = useState("Missing");

  const handleSetConditionRadioValue = (radioValue: string) => {
    setCondition(radioValue);
  };

  useEffect(() => {
    setCondition(singleFixedAsset?.condition);
  }, [singleFixedAsset?.condition]);

  return (
    <div
      className="flex-center"
      style={{ flexDirection: "column", alignItems: "flex-start" }}
    >
      {/* <div
        className="close-btn"
        onClick={() => {
          handleReset();
          message === "Fixed asset verification has been added successfully!" &&
            onClose &&
            onClose();
        }}
      >
        <img src={CloseIcon} alt="" />
      </div> */}

      {message === "Fixed asset verification has been added successfully!" ? (
        <VerificationSuccess
          handleReset={handleReset}
          // onClose={onClose}
          history={history}
          clientCode={clientCode}
        />
      ) : (
        <SingleAssetDetail
          handleReset={handleReset}
          singleFixedAsset={singleFixedAsset}
          handleSubmit={handleSubmit}
          condition={condition}
          setCondition={setCondition}
          handleSetConditionRadioValue={handleSetConditionRadioValue}
        />
      )}
    </div>
  );
};

export default AssetDetails;
